import { RiLoader2Fill } from '@remixicon/react';
import { cn } from '@/shared/lib/cn';

export interface SpinnerProps {
  /** Glyph size in design px. Default 16. */
  size?: 12 | 14 | 16 | 18 | 20 | 24 | 32;
  /** Visible text next to the glyph, e.g. "Yuklanmoqda..." (102:3311). */
  label?: React.ReactNode;
  /** Accessible label when no visible label is given. */
  'aria-label'?: string;
  className?: string;
}

const SIZE: Record<NonNullable<SpinnerProps['size']>, string> = {
  12: 'size-12',
  14: 'size-14',
  16: 'size-16',
  18: 'size-18',
  20: 'size-20',
  24: 'size-24',
  32: 'size-32',
};

/** Kit loading glyph `loader-2-fill` (67:9574 "State=Loading"), spinning. Inherits `currentColor`. */
export function Spinner({ size = 16, label, className, 'aria-label': ariaLabel = 'Yuklanmoqda' }: SpinnerProps) {
  return (
    <output
      aria-live="polite"
      aria-label={label ? undefined : ariaLabel}
      className={cn('inline-flex items-center gap-8 text-13 leading-18 text-fg-secondary', className)}
    >
      <RiLoader2Fill aria-hidden className={cn('shrink-0 animate-spin text-icon', SIZE[size])} />
      {label}
    </output>
  );
}
